import { Button, HStack, IconButton } from "@chakra-ui/react";
import React from "react";
import { LuChevronLeft, LuChevronRight, LuChevronsLeft, LuChevronsRight } from "react-icons/lu";

export const CustomPagination = ({ totalCount, current, setCurrent, isLoading }) => {
  const handleFirst = () => {
    if (current !== 1) {
      setCurrent(1);
    }
  };

  const handleLast = () => {
    if (current !== totalCount) {
      setCurrent(totalCount);
    }
  };

  const handlePrev = () => {
    if (current > 1) {
      setCurrent(current - 1);
    }
  };

  const handleNext = () => {
    if (current < totalCount) {
      setCurrent(current + 1);
    }
  };

  // Compute 5 page numbers around `current`
  const getButtonLabels = () => {
    if (totalCount <= 5) {
      return Array.from({ length: totalCount }, (_, i) => i + 1);
    }

    let start = Math.max(1, current - 2);
    let end = start + 4;

    if (end > totalCount) {
      end = totalCount;
      start = end - 4;
    }

    return Array.from({ length: 5 }, (_, i) => start + i);
  };

  const pageLabels = getButtonLabels();

  return (
    <HStack spacing={1}>
      <Button
        variant="outline"
        size="sm"
        onClick={handleFirst}
        disabled={current === 1 || totalCount === 1 || isLoading}
        aria-label="First"
      >
        <LuChevronsLeft />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={handlePrev}
        disabled={current === 1 || totalCount === 1 || isLoading}
        aria-label="Previous"
      >
        <LuChevronLeft />
        Prev
      </Button>

      {pageLabels.map((label, idx) => (
        <IconButton
          key={idx}
          variant={label === current ? "solid" : "outline"}
          disabled={isLoading}
          size="sm"
          onClick={() => setCurrent(label)}
        >
          {label}
        </IconButton>
      ))}

      <Button
        variant="outline"
        size="sm"
        onClick={handleNext}
        disabled={current === totalCount || totalCount === 1 || isLoading}
        aria-label="Next"
      >
        Next
        <LuChevronRight />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={handleLast}
        disabled={current === totalCount || totalCount === 1 || isLoading}
        aria-label="Last"
      >
        <LuChevronsRight />
      </Button>
    </HStack>
  );
};